import { Card, Text, Button, Group, Stack } from '@mantine/core';

interface JoinPremiumProps {
  title?: string;
  description: string;
  learnMoreText?: string;
  joinText?: string;
  onLearnMore?: () => void;
  onJoinPremium?: () => void;
}

export default function JoinPremium({
  title = "You've found the most powerful TH feature.",
  description,
  learnMoreText = 'LEARN MORE',
  joinText = 'JOIN PREMIUM',
  onLearnMore,
  onJoinPremium,
}: JoinPremiumProps) {
  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder>
      <Stack gap="md">
        <Text fw={600} size="lg">
          {title}
        </Text>

        <Text size="sm" c="dimmed" style={{ lineHeight: 1.5 }}>
          {description}
        </Text>

        <Group justify="flex-end" gap="sm">
          {onLearnMore && (
            <Button variant="light" size="sm" onClick={onLearnMore}>
              {learnMoreText}
            </Button>
          )}
          <Button color="yellow" size="sm" onClick={onJoinPremium}>
            {joinText}
          </Button>
        </Group>
      </Stack>
    </Card>
  );
}
